import React from 'react';
import { MessageCircle } from 'lucide-react';
import { whatsappNumber } from '../data/mock';

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Halo Griya Bakpia, saya ingin bertanya tentang produk Anda.');
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center animate-in zoom-in fade-in duration-500 group"
      aria-label="Chat via WhatsApp"
    >
      <div className="absolute right-full mr-3 bg-white text-[#3E2723] px-3 py-1.5 rounded-lg shadow-xl text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap border border-gray-100">
        Tanya Kami di WhatsApp
      </div>
      <MessageCircle size={32} fill="currentColor" className="text-white" />
      <span className="absolute top-0 right-0 flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
      </span>
    </button>
  );
};

export default WhatsAppFloat;
